import React, { PureComponent} from 'react'
import { connect } from 'react-redux'
import injectSheet from 'react-jss'
import cn from 'classnames'
import {getWishlistItems} from '../../selectors'
import {addToWishlist, removeFromWishlist} from '../../actions/account'
import CircleSpinner from "../Widgets/CircleSpinner"
import SVGSymbol from '../SVGSymbol'
import heartFilledImg from '../../img/icons/heart-filled.svg'
import heartImg from '../../img/icons/heart.svg'

class AddToWishlist extends PureComponent {

    _onAddToWishlistClick = (event) => {
        event.preventDefault();
        event.stopPropagation();
        const {product, wishlistItems, handleAddToWishlist, handleRemoveFromWishlist} = this.props;
        const wishlistItem = wishlistItems[product.sku];
        if(wishlistItem)
            handleRemoveFromWishlist(product.sku);
        else
            handleAddToWishlist(product.sku);
    }

    render() {
        const {classes, className, classNames={}, product, wishlistItems} = this.props;
        if(!product) return null;

        const wishlistItem = wishlistItems[product.sku];
        const loading = wishlistItem && (wishlistItem.state === 'adding' || wishlistItem.state === 'removing');

        var HeartIcon = () => wishlistItem ? 
            <SVGSymbol key='heartFilledImg' icon={heartFilledImg} className={cn(classes.icon, 'added', classNames.icon)} /> :
            <SVGSymbol key='heartImg' icon={heartImg} className={cn(classes.icon, classNames.icon)} />;

        return <div onClick={this._onAddToWishlistClick} className={cn(classes.iconContainer, className, classNames.container)}>
            <CircleSpinner show={loading} className={classes.icon}/>
            {!loading && <HeartIcon />}
        </div>
    }
}

const mapStateToProps = (state) => {
    return {
        wishlistItems: getWishlistItems(state)
    }
}

function mapDispatchToProps(dispatch) {
    return {
        handleAddToWishlist: (sku) => {
            dispatch(addToWishlist(sku))
        },
        handleRemoveFromWishlist: (sku) => {
            dispatch(removeFromWishlist(sku))
        },
    }
}

export default injectSheet( (theme) => (
{
    spinnerContainer: {
        position: 'absolute',
        top: 3,
        left: 0
    },
    spinner: {
        fill: theme.colors.white,
        width: 24,
        height: 24
    },
    iconContainer: {
        display: 'block'
    },
    icon: {
        color: theme.colors.black,
        stroke: theme.colors.black,
        width: 18,
        height: 18,
        margin: '3px 0 5px 5px',
        cursor: 'pointer',
        "&.added, &:hover": {
            color: theme.colors.primary,
            stroke: theme.colors.primary,
        }

    },

}))(connect(mapStateToProps, mapDispatchToProps)(AddToWishlist))





// WEBPACK FOOTER //
// ./src/components/ShopThLook/AddToWishlist.js